// Estados normalizados que devuelve el backend en la verificación de pago móvil (T2/T9).
export enum BankValidationStatus {
    CONFIRMED = 'CONFIRMED',
    NOT_FOUND = 'NOT_FOUND',
    MAINTENANCE = 'MAINTENANCE',
    TIMEOUT = 'TIMEOUT',
    INVALID_CREDENTIALS = 'INVALID_CREDENTIALS',
    VALIDATION_ERROR = 'VALIDATION_ERROR',
    UNKNOWN_ERROR = 'UNKNOWN_ERROR',
}

// Body de POST /pos/sales/verify-payment. El backend normaliza teléfono y código de banco, así
// que el frontend manda `bankOrigin` como string de 4 dígitos y `phone` en formato nacional.
export interface VerifyPaymentRequest {
    tenantId: string;
    saleId: string;
    paymentMethodId: string;
    bankOrigin: string;
    phone: string;
    reference: string;
    amount: number;
    date: string;
    cedula?: string;
}

export interface VerifyPaymentResponse {
    status: BankValidationStatus;
    message: string;
    checkedReference?: string;
}

// Lo que devuelve el modal de verificación al cerrarse (checkout y Cuentas bancarias).
export interface MobileVerificationResult {
    status: BankValidationStatus | null;
    checkedReference: string;
}

// "Validado" debe coincidir con el badge de Registro de pedidos (isPaymentValidated).
export const BANK_VALIDATION_LABELS: Record<BankValidationStatus, string> = {
    [BankValidationStatus.CONFIRMED]: 'Validado',
    [BankValidationStatus.NOT_FOUND]: 'No encontrado',
    [BankValidationStatus.MAINTENANCE]: 'Banco en mantenimiento',
    [BankValidationStatus.TIMEOUT]: 'En espera del banco',
    [BankValidationStatus.INVALID_CREDENTIALS]: 'Credenciales inválidas',
    [BankValidationStatus.VALIDATION_ERROR]: 'Datos inválidos',
    [BankValidationStatus.UNKNOWN_ERROR]: 'Error de verificación',
};
